import { createContext, type ReactNode, useContext } from 'react';
import { usePhieuThanhToanTamUngExport } from './hooks';

interface PhieuThanhToanTamUngContextValue {
  exportToExcel: () => Promise<void>;
  canExport: boolean;
  isExporting: boolean;
}

const PhieuThanhToanTamUngContext = createContext<PhieuThanhToanTamUngContextValue | null>(null);

export const usePhieuThanhToanTamUngContext = () => {
  const context = useContext(PhieuThanhToanTamUngContext);
  if (!context) {
    throw new Error('usePhieuThanhToanTamUngContext must be used within PhieuThanhToanTamUngProvider');
  }
  return context;
};

export const PhieuThanhToanTamUngProvider = ({ children }: { children: ReactNode }) => {
  const { exportToExcel, canExport, isExporting } = usePhieuThanhToanTamUngExport();

  return (
    <PhieuThanhToanTamUngContext.Provider
      value={{
        exportToExcel,
        canExport,
        isExporting
      }}
    >
      {children}
    </PhieuThanhToanTamUngContext.Provider>
  );
};
